import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, TextArea } from '@ygtechnologies/bygr-frontend-component-library';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { triggerHandler } from '@ygtechnologies/rubus-frontend-utilities';
import { retractChangeRequestBuyerOffer } from '@/services/change-requests';
import { Button, ButtonBar } from '@ygtechnologies/rubus-ui';

interface ChangeRequestRetractOfferDialogProps {
    changeRequestId: number;
    show: boolean;
    onClose(): void;
    onSave(): void;
}

const ChangeRequestRetractOfferDialog: React.FC<ChangeRequestRetractOfferDialogProps> = ({
    show,
    onClose,
    onSave,
    changeRequestId,
}) => {
    const [note, setNote] = useState('');
    const [sending, setSending] = useState(false);

    const handleSaveClick = async () => {
        setSending(true);

        try {
            await retractChangeRequestBuyerOffer(changeRequestId, note);
            triggerHandler(onSave);
            triggerHandler(onClose);
        } finally {
            setSending(false);
        }
    };

    const handleCancelClick = () => {
        triggerHandler(onClose);
    };

    const reset = () => {
        setNote('');
    };

    return (
        <Modal isOpen={show} toggle={handleCancelClick} onOpen={reset} size="lg">
            <ModalHeader>
                <Trans>Retract offer</Trans>
            </ModalHeader>
            <ModalBody>
                <div className="form-group">
                    <label>
                        <Trans>Message</Trans>
                    </label>
                    <TextArea
                        autoResize={true}
                        value={note}
                        name="note"
                        className="form-control"
                        placeholder={t`You can add a message to the buyer to explain why you retracted the offer`}
                        onChange={(e) => setNote(e.target.value)}
                        minRows={5}
                    />
                </div>
            </ModalBody>
            <ModalFooter>
                <ButtonBar margins="none">
                    <ButtonBar.Right>
                        <Button variant="tertiary" onClick={handleCancelClick} disabled={sending}>
                            <Trans>Cancel</Trans>
                        </Button>
                        <Button variant="primary" onClick={handleSaveClick} loading={sending}>
                            <Trans>Retract offer</Trans>
                        </Button>
                    </ButtonBar.Right>
                </ButtonBar>
            </ModalFooter>
        </Modal>
    );
};

export default ChangeRequestRetractOfferDialog;